module.exports = __webpack_public_path__ + "img/intro.19bded1b.jpg";